var path = 'areas/shared/views/selector/match-role.html';
var html = "{{$item}}";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/match-role.html
// module id = 1588391643079086
// module chunks = 1